import { ContainerModule } from '@patsnap/tahiti-core/shared/inversify';
import { ShareAuthApi } from './apis/share-auth-api';
import { ShareAuthApiImpl } from './apis/impls/share-auth-api';
import { AuthService } from './services/auth-service';
import { AuthServiceImpl } from './services/impls/auth-service';
import { AuthModel } from './models/auth.model';
import { AuthModelImpl } from './models/impls/auth.model';
import { ShareI18nService } from './services/share-i18n-service';
import { i18n } from '../i18n';

/**
 * 最小化的 authModule，只包含 AuthService 及其依赖
 * 适用于只需要权限检查功能的项目
 */
export const authModule = new ContainerModule((bind) => {
    bind(ShareI18nService).toConstantValue({
        t: i18n.global.t.bind(i18n),
        locale: i18n.global.locale.value,
    });
    // AuthService 依赖
    bind(ShareAuthApi).to(ShareAuthApiImpl);
    bind(AuthService).to(AuthServiceImpl);
    bind(AuthModel).to(AuthModelImpl);
});
